import { Box, styled } from '@mui/material';

export const Container = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'width' &&
    prop !== 'minHeight' &&
    prop !== 'maxHeight' &&
    prop !== 'componentOrder',
})(({ width, minHeight, maxHeight, componentOrder }) => ({
  width: width ?? 'auto',
  minHeight,
  maxHeight,
  display: 'flex',
  flexDirection: 'column',
  order: componentOrder,
  position: 'relative',
}));
